import {Injectable} from '@angular/core';
import {HttpClientService} from "@allianzch/ngx-core-ch";
import {HttpClient, HttpHeaders, HttpParams} from "@angular/common/http";
import {Observable} from "rxjs";
import {environment} from "../../environments/environment";

@Injectable({
  providedIn: 'root'
})

export class MailService {
  public client = environment.client;

  constructor(private http: HttpClient, private https: HttpClientService) {
  }



  sendALMail({userData_}: { userData_: any }): Observable<any> {

    const params = new HttpParams(userData_);

    let httpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    console.log('params')

      return this.http.post<any>((this.client=='cap')?' https://www.cap.ch/crp/dsp_bff_lead4you/ext/v1/leads':'https://www.allianz.ch/crp/dsp_bff_lead4you/ext/v1/leads', JSON.stringify(userData_),
        {headers: httpHeaders}
      );
  }

}
